module.exports={
  "title": "Steps to book your repair",

  "steps": [
    {
      "title": "Step 1",
      "description": "Select your product",
      "alt": "Closed hand image with index finger open in a rounded grey background",
      "image": "intro-step1.png"
    },

    {
      "title": "Step 2",
      "description": "Troubleshoot the issue",
      "alt": "Clipboard image with five lines and tick mark in a circle in a rounded grey background",
      "image": "intro-step2.png"
    },

    {
      "title": "Step 3",
      "description": "Select your preferred repair option",
      "alt": "Crossed Spaner and screw driver image in a rounded grey background",
      "image": "intro-step3.png"
    },

    {
      "title": "Step 4",
      "description": "Enter your details to book the repair with our Authorised Service Partner",
      "alt": "Clipboard image with two lines in a rounded grey background",
      "image": "intro-step4.png"
    },

    {
      "title": "Step 5",
      "description": "You will receive an email confirmation for your repair booking",
      "alt": "Tick mark image in a rounded grey background",
      "image": "intro-step5.png"
    }
  ],

  "xxx": "copy end"
}
